import { createUseStyles } from 'react-jss';
import { color, fontSize, radius, spacing } from '@blink/components';

export const useBorrowRateStyle = createUseStyles({
    borrowRateWrapper: {
        marginTop: spacing['06'],
        borderRadius: 4,
        border: `1px solid ${color.border.opaque}`,
        padding: '16px 0',
        marginBottom: spacing['04'],
    },
    borrowRateItem: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0 16px 16px 16px',

        '&:last-child': {
            paddingBottom: 0,
        },
    },
    borrowRateValues: {
        fontWeight: 600,
        fontSize: fontSize.md,
        lineHeight: '20px',
        margin: 0,
    },
    flex: {
        display: 'flex',
        alignItems: 'center',
    },
    icon: {
        display: 'flex',
        alignSelf: 'center',
        marginRight: spacing['02'],
    },
    tooltipRoot: {
        borderRadius: radius.overall,
        width: 'fit-content',
        marginRight: spacing['02'],
        '& .ant-tooltip-arrow': {
            top: 1,
        },
        '& .ant-tooltip-inner': {
            display: 'flex',
            minWidth: 96,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: spacing['02'],
            padding: '8px 12px',
            border: `1px solid transparent`,
            background: `${color.background.inversePrimary} !important`,
        },
        '& .ant-tooltip-arrow:before': {
            background: `${color.background.inversePrimary} !important`,
        },
        '&.ant-tooltip': {
            fontSize: `${fontSize.sm} !important`,
            maxWidth: 320,
            color: color.content.inversePrimary,
        },
    },
    micro: {
        '&.ant-skeleton-input': {
            width: '48px !important',
            height: '20px !important',
            minWidth: '48px !important',
            borderRadius: 4,
        },
    },
    title: {
        color: color.content.fourth,
        fontSize: 14,
        fontStyle: 'normal',
        fontWeight: 500,
        margin: 0,
    },
});
